import cloneDeep from 'lodash/cloneDeep';

import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import {
  fetchMediaTemplate,
  fetchFonts,
  updateMediaTemplate,
  previewMediaTemplate,
} from 'app/actions/media-templates.actions';

import template from './template-tab.html';
import confirmationTemplate from '../confirmation-dialog/confirmation-dialog.html';

const mapStateToThis = ({
  session, dirtyForms, mediaTemplates,
}) => {
  const { locale } = session;
  const {
    isLoading, isSaving, entries, fonts, error,
  } = mediaTemplates;

  return {
    dirtyForms,
    locale,
    entries,
    fonts,
    isLoading,
    isSaving,
    error,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchMediaTemplate,
  fetchFonts,
  updateMediaTemplate,
  previewMediaTemplate,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'Notifications')
class TemplateTabController {
  constructor() {
    this.DIRTY_FORM = this.posterName;
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    await Promise.all([
      this.fetchMediaTemplate(this.posterName),
      this.fetchFonts(),
    ]);
    this.initForm();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initForm() {
    this.textAlignmentOptions = this.getTextAlignmentOptions();
    this.cloneEntries();
  }

  cloneEntries() {
    this.editableEntries = cloneDeep(this.entries);
    this.editableEntries.forEach((entry) => {
      if (entry.imageUrl) {
        entry.image = [{ name: entry.imageUrl }];
      }
    });
  }

  getTextAlignmentOptions() {
    return [
      {
        id: 'justify',
        label: this.gettextCatalog.getString('Justify'),
      },
      {
        id: 'center',
        label: this.gettextCatalog.getString('Center'),
      },
      {
        id: 'right',
        label: this.gettextCatalog.getString('Right'),
      },
      {
        id: 'left',
        label: this.gettextCatalog.getString('Left'),
      },
    ];
  }

  async preview(form) {
    form.$setSubmitted();

    if (form.$valid && !this.fileErrors) {
      const posterParams = await this.Notifications.showComplexDialog({
        component: 'posterPreviewFormDialog',
        backdrop: 'static',
        size: 'sm',
        resolve: {
          gameType: () => this.gameType,
        },
      }).result;

      if (posterParams) {
        const entry = cloneDeep(this.editableEntries[0]);

        this.showStartPreviewNotification();
        await this.previewMediaTemplate(entry, posterParams);
        this.hideNotification();

        if (this.error) {
          this.showErrorPreviewNotification();
        }
      }
    }
  }

  async save(form) {
    form.$setSubmitted();

    if (form.$valid && !this.fileErrors) {
      this.Notifications.showComplexDialog({
        template: confirmationTemplate,
      }).result.then(async () => {
        const entries = cloneDeep(this.editableEntries);

        this.showStartSavingNotification();
        await this.updateMediaTemplate(entries);
        this.hideNotification();

        if (this.error) {
          this.showErrorSavingNotification();
        } else {
          this.showSuccessSavingNotification();
          this.setDirtyForm(this.DIRTY_FORM, false);
        }
      });
    }
  }

  cancel() {
    this.cloneEntries();
    this.showSuccessCancelNotification();
  }

  showStartPreviewNotification() {
    this.Notifications.customNotification(
      {
        message: this.gettextCatalog.getString('Generating poster...'),
        timeOut: 0,
      },
      'toast',
      'info',
    );
  }

  showStartSavingNotification() {
    this.Notifications.customNotification(
      {
        message: this.gettextCatalog.getString('Saving template...'),
        timeOut: 0,
      },
      'toast',
      'info',
    );
  }

  hideNotification() {
    this.Notifications.clear();
  }

  showSuccessSavingNotification() {
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Template saved successfully.'));
  }

  showErrorPreviewNotification() {
    this.Notifications.alertError(this.gettextCatalog.getString('Error while generating poster.'));
  }

  showErrorSavingNotification() {
    this.Notifications.alertError(this.gettextCatalog.getString('Error while saving template.'));
  }

  showSuccessCancelNotification() {
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been canceled.'));
  }
}

export default class TemplateTabComponent {
  constructor() {
    this.controller = TemplateTabController;
    this.template = template;
    this.bindings = {
      posterName: '@',
      gameType: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/media-templates/components/template-tab/template-tab-component.js